import classes from "./Kiosk_settings.module.css";
import {Button, CircularProgress, FormControl, FormLabel, Radio, RadioGroup, Typography} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import kioskFull from "../../../../store/Vienna_new/kiosk-full.png"
import kioskFullWH from "../../../../store/Vienna_new/kiosk_fulWH.png"
import kioskFullW0H from "../../../../store/Vienna_new/kiosk_fulWOH.png"
import {useState, useEffect} from "react";
import axios from "axios";
import {path} from "../../../../routes";

const KioskSettings = (props) => {
    const stateFromProps = Number(props.data?.KioskState);
    const initial = (stateFromProps === 0 || stateFromProps === 1 || stateFromProps === 2) ? stateFromProps : 0;
    const [radData, setRadData] = useState(initial);
    const [loading, setLoading] = useState(false);
    const canEdit = props.readOnly !== true;

    // Sync from props only when opening for a different device (by id), so we don't overwrite after save
    useEffect(() => {
        if (props.data?.id == null) return;
        const v = Number(props.data.KioskState);
        setRadData((v === 0 || v === 1 || v === 2) ? v : 0);
    }, [props.data?.id]);

    const update_handler = async () => {
        const stateVal = Number(radData);
        if (stateVal !== 0 && stateVal !== 1 && stateVal !== 2) return;
        setLoading(true);
        try {
            await axios.post(`${path}/updateKiosk/${props.data.id}/${stateVal}`);
            setLoading(false);
            const updated = { ...props.data, KioskState: stateVal };
            if (typeof props.onSaved === 'function') props.onSaved(updated);
        } catch (err) {
            setLoading(false);
            setRadData(initial);
            console.error(err);
            alert('Failed to save settings.');
        }
    }


    if (!props.data) return null;

    return <div className={classes.mainCont}>
        <div className={classes.head}>{props.data.description ?? 'Kiosk'}</div>
        <div className={classes.body}>
            <div className={classes.ill}>
                <img src={radData === 0 ? kioskFull : radData === 1 ? kioskFullWH : radData === 2 ? kioskFullW0H : kioskFull} alt="" />
            </div>
            <div className={classes.rad}>
                <FormControl>
                    <FormLabel id="kiosk-state-label">KioskState – display mode (0 / 1 / 2)</FormLabel>
                    <RadioGroup
                        aria-labelledby="kiosk-state-label"
                        name="kiosk-state"
                        value={String(radData)}
                        onChange={(e) => {
                            if (canEdit && !loading) {
                                setRadData(Number(e.target.value));
                            } else if (!canEdit) {
                                alert('You do not have permission to change kiosk settings.');
                            }
                        }}
                    >
                        <FormControlLabel 
                            value="0" 
                            control={<Radio />} 
                            label="0 – Default kiosk graphics"
                            sx={{ opacity: canEdit ? 1 : 0.5 }}
                        />
                        <FormControlLabel 
                            value="1" 
                            control={<Radio />} 
                            label="1 – Fullscreen with Header"
                            sx={{ opacity: canEdit ? 1 : 0.5 }}
                        />
                        <FormControlLabel 
                            value="2" 
                            control={<Radio />} 
                            label="2 – Fullscreen without Header"
                            sx={{ opacity: canEdit ? 1 : 0.5 }}
                        />
                    </RadioGroup>
                    {!canEdit && (
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, fontStyle: 'italic' }}>
                            Read-only: You need permission to edit kiosk settings.
                        </Typography>
                    )}
                </FormControl>
            </div>
        </div>
        <div className={classes.footer}>
            {canEdit && !loading && <Button sx={{width: "50%"}} variant="outlined" onClick={update_handler}>Update</Button>}
            {loading && <CircularProgress color="secondary" />}
        </div>
    </div>
}

export default KioskSettings;